import { useMsal } from '@azure/msal-react'
import ApiClient from './../../../api/ApiClient';
import { useApiClient } from '../../../context/AppContext';

const SignOutButton = () => {
    const apiClient = useApiClient();
    const { instance } = useMsal()
    
    const handleSignOut = () => {
        instance.logoutRedirect()
    }
    const getUsername = (apiClient: ApiClient) =>{
        return apiClient.getUsername()
    }
    const username = getUsername(apiClient);

    return (
        <div className='ln-c-topbar__item ln-c-header__global-item'>
            <span className=' ln-c-topbar__text ln-u-soft-right username logOut'>{username}</span>
            <a
                className='ln-o-bare-link ln-c-topbar__text logOut'
                href='#signout'
                id='logout'
                key='logout'
                aria-selected='true' role='tab'
                aria-controls='logout'
                onClick={handleSignOut}
            >Logout</a>
        </div>
    )
}

export default SignOutButton